"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLanguage = exports.languageSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Even though this is `locale`, we call it `language` to be consistent with ASMS.
const languageSchema = exports.languageSchema = zod.string().regex(/^[a-z]{2}-[A-Z]{2}$/);

/**
 * Validates the provided language against the language schema.
 *
 * @param language - The language string to be validated - should be string in form of "ab-CD".
 * @returns The validated language data if the validation is successful, otherwise `undefined`.
 */
const validateLanguage = language => {
  const result = languageSchema.safeParse(language);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateLanguage = validateLanguage;
